import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import "./sidebar.css";
import FpoSelector from "./FpoSelector";

function NavigationGroup({ id, title, children, containsRoute, pathname }) {
  const [expanded, setExpanded] = useState(true);

  useEffect(() => {
    if (containsRoute) setExpanded(true);
  }, [pathname, containsRoute]);

  return (
    <li className="sidebar-group">
      <button type="button" className="sidebar-group-toggle"
        aria-label={title} aria-expanded={expanded} aria-controls={`sidebar-${id}`}
        onClick={() => setExpanded(value => !value)}>
        <span>{title === "PROCUREMENT" ? "Procurement" : title}</span>
        <span aria-hidden="true">{expanded ? "▾" : "▸"}</span>
      </button>
      <ul id={`sidebar-${id}`} hidden={!expanded}>{children}</ul>
    </li>
  );
}

function NavigationLink({ to, children }) {
  return <li className="sidebar-link-item"><NavLink to={to} end
    className={({ isActive }) => `sidebar-link${isActive ? " active" : ""}`}>
    {children}
  </NavLink></li>;
}

export default function Sidebar() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const role = localStorage.getItem("role") || "fpo_admin";

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("fpo_id");
    localStorage.removeItem("email");
    navigate("/login");
  };

  if (role === "super_admin") {
    return (
      <div className="sidebar">
        <FpoSelector />
        <ul>
          <NavigationGroup id="dashboards" title="DASHBOARDS" pathname={pathname}
            containsRoute={pathname === "/dashboard" || pathname.startsWith("/dashboard/")}>
            <NavigationLink to="/dashboard">FPO Overview</NavigationLink>
            <NavigationLink to="/dashboard/sales-velocity">Sales Velocity</NavigationLink>
          </NavigationGroup>
          <li onClick={() => navigate("/super-admin")}>
            Super Admin Dashboard
          </li>
          <li onClick={() => navigate("/fpos")}>FPO Master</li>
          <li onClick={() => navigate("/procurement")}>Procurement</li>
          <li onClick={() => navigate("/admin-users")}>FPO Admin Users</li>

          <li style={{ marginTop: "12px", fontWeight: "bold", color: "#444" }}>
            Masters
          </li>

          <li onClick={() => navigate("/masters/product-categories")}>
            Product Categories
          </li>

          <li onClick={() => navigate("/masters/product-units")}>
            Product Units
          </li>

          <li onClick={() => navigate("/masters/geography")}>
            Geography Master
          </li>

          <li onClick={() => navigate("/change-password")}>
            Change Password
          </li>

          <li
            onClick={handleLogout}
            style={{ marginTop: "20px", color: "#b00020" }}
          >
            Logout
          </li>
        </ul>
      </div>
    );
  }

  return (
    <nav className="sidebar" aria-label="FPO Admin navigation">
      <FpoSelector />
      <ul>
        <NavigationGroup id="dashboards" title="DASHBOARDS" pathname={pathname}
          containsRoute={pathname === "/dashboard" || pathname.startsWith("/dashboard/")}>
          <NavigationLink to="/dashboard">FPO Overview</NavigationLink>
          <NavigationLink to="/dashboard/sales-velocity">Sales Velocity</NavigationLink>
        </NavigationGroup>
        <NavigationGroup id="procurement" title="PROCUREMENT" pathname={pathname}
          containsRoute={pathname === "/procurement" || pathname.startsWith("/procurement/")}>
          <NavigationLink to="/procurement">Configuration</NavigationLink>
          <NavigationLink to="/procurement/warehouses">Warehouses</NavigationLink>
          <NavigationLink to="/procurement/dispatches">Dispatch Monitor</NavigationLink>
        </NavigationGroup>
        <NavigationGroup id="users" title="USERS & ACCESS" pathname={pathname}
          containsRoute={["/agents", "/standalone-aggregators", "/warehouse-managers", "/shareholders", "/authorized-persons"].includes(pathname) || pathname.startsWith("/agent-geo-mapping/")}>
          <NavigationLink to="/agents">Agents</NavigationLink>
          <NavigationLink to="/standalone-aggregators">Standalone Aggregators</NavigationLink>
          <NavigationLink to="/warehouse-managers">Warehouse Managers</NavigationLink>
          <NavigationLink to="/shareholders">Shareholders</NavigationLink>
          <NavigationLink to="/authorized-persons">Authorised Persons</NavigationLink>
        </NavigationGroup>
        <NavigationLink to="/products">Products</NavigationLink>
        <NavigationLink to="/sales-report">Sales Report</NavigationLink>
        <NavigationLink to="/reports">Reports</NavigationLink>
        <NavigationGroup id="inventory" title="INVENTORY" pathname={pathname}
          containsRoute={pathname.startsWith("/inventory/")}>
          <NavigationLink to="/inventory/opening">Opening Stock</NavigationLink>
          <NavigationLink to="/inventory/purchase">Purchase / Stock-In</NavigationLink>
          <NavigationLink to="/inventory/ledger">Inventory Ledger</NavigationLink>
        </NavigationGroup>
        <NavigationLink to="/stock-allocation">Stock Allocation</NavigationLink>
        <NavigationLink to="/agent-settlement">Agent Settlement</NavigationLink>
        <NavigationLink to="/change-password">Change Password</NavigationLink>
        <li className="sidebar-link-item"><button type="button" className="sidebar-logout" onClick={handleLogout}>Logout</button></li>
      </ul>
    </nav>
  );
}
